import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { AccountingSettingsContainer } from "@/screens/Accounting/subfeatures/Settings"

export const Route = createFileRoute("/app/admin/accounting/_layout/settings")({
  component: () => (
    <PermissionContentWrapper
      permissions={[PermissionActionType.ACCOUNTING_MANAGER, PermissionActionType.ACCOUNTING_MAINTENANCE]}
    >
      <AccountingSettingsContainer />
    </PermissionContentWrapper>
  ),
})
